/*
    Imports the Roast API URL from the config.
*/

import apiCtrl from '@/services/api/abstract/abstract-api.js';
// import axios from "axios";
export default {
  /*
        POST    /api/v1/document
    */
  postDocument: function(data) {
    return apiCtrl.postUpload('/document', data);
  },

  getConfig: function(data = {}) {
    return apiCtrl.get('/config/document', data);
  },
};
